// third party imports
import React from 'react';

// internal rebet imports
import './stylesAllUsers.css'

// component imports
import UserTable from './UsersTable/UserTable';
import { usePageTitle } from '../../CommonComponents/Layout/PageTitleContext';
import { AppStrings } from '../../../utils/constants/AppStrings';
// asset imports


const AllUsers = () => {
  usePageTitle(AppStrings.APP_USERS);

  return (
    <>
      <UserTable/>
    </>
  );
};

export default AllUsers;

